import { useTranslation } from 'react-i18next'
import { HStack, Icon } from '@chakra-ui/react'
import { Clock, Users, Navigation } from 'react-feather'

import { Caption } from 'atoms/typography'

interface WalkMetadataProps {
  ageRange: string
  distance: string
  duration: string
}

const WalkMetadata: React.FC<WalkMetadataProps> = ({
  ageRange,
  distance,
  duration,
}) => {
  const { t } = useTranslation()

  return (
    <HStack spacing="6" justifyContent={{ base: 'center', sm: 'flex-start' }}>
      <Caption color="charcoal" aria-label={t('walkLanding.durationAriaLabel')}>
        <Icon as={Clock} mr="2" />
        {duration}
      </Caption>
      <Caption color="charcoal" aria-label={t('walkLanding.ageRangeAriaLabel')}>
        <Icon as={Users} mr="2" />
        {ageRange}
      </Caption>
      <Caption color="charcoal" aria-label={t('walkLanding.distanceAriaLabel')}>
        <Icon as={Navigation} mr="2" />
        {distance}
      </Caption>
    </HStack>
  )
}

export default WalkMetadata
